import React, { useState } from "react"
import { AxiosError } from "axios"

import { authStore } from "@src/app/authStore"
import { notify } from "@src/app/components/notify"
import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { APIResponse } from "@src/shared/api"

interface Error {
  message: string
  target: string
}

interface Errors {
  errors?: Errors[]
  message: string
  target: string
}

export interface ErrorsData {
  index?: string
  message: string
  target: string
}

export const useFormErrors = () => {
  const [normalizedErrorsData, setNormalizedErrorsData] = useState<
    ErrorsData[]
  >([])

  const catchFormErrors = (error: AxiosError<APIResponse>) => {
    setNormalizedErrorsData([])

    if (error.isAxiosError && error.response) {
      if (error.response.status == 401) {
        if (authStore.merchant) {
          router.navigate(paths.auth).finally(() => {
            authStore.reset()
          })
        }
      } else if (error?.response?.data?.error?.errors?.length > 0) {
        normalizeErrors(error?.response?.data?.error?.errors)

        if (
          error?.response?.data?.error?.errors[0]?.message === "invalid OTP"
        ) {
          notify.error(
            error?.response?.data?.error?.errors[0]?.message,
            error.response.headers["x-trace-id"],
          )
        }
      } else {
        if (error?.response?.data?.error) {
          notify.error(
            error?.response?.data?.error?.message,
            error.response.headers["x-trace-id"],
          )
        }
      }
    }
  }

  const normalizeErrors = (errors: Errors[]) => {
    const errorsData: ErrorsData[] = []

    errors.forEach((element: Errors) => {
      if (!element?.errors) {
        errorsData.push(element)
      } else {
        element?.errors?.map(({ errors, target: index }: Errors) => {
          errors?.map(({ message, target }: Error) => {
            errorsData.push({ index, message, target })
          })
        })
      }
    })

    setNormalizedErrorsData(errorsData)
  }

  const getErrorMessage = (name: string, key?: number) => {
    let message = ""

    let index: number | undefined = undefined

    if (key === undefined) {
      message = normalizedErrorsData?.find((error) => error.target === name)
        ?.message as string
    } else {
      index = Number(
        normalizedErrorsData.find((error) => Number(error.index) === key)
          ?.index,
      )

      message = normalizedErrorsData
        ?.filter((error) => Number(error.index) === key)
        .find((error) => error.target === name)?.message as string
    }

    return {
      hasError: Boolean(message),
      index,
      message: React.createElement(
        "span",
        { style: { color: "#ff4d4f" } },
        message,
      ),
    }
  }

  const resetErrors = () => setNormalizedErrorsData([])

  return {
    catchFormErrors,
    getErrorMessage,
    resetErrors,
  }
}
